import { createContext, useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { api } from "./api";
import Login from "./Login";
import AdminLayout from "./AdminLayout";
import Inquiries from "./Inquiries";
import Invoices from "./Invoices";

const AuthCtx = createContext(null);
export const useAdminAuth = () => useContext(AuthCtx);

export default function AdminApp() {
  const [auth, setAuth] = useState(null); // null=checking, true, false

  useEffect(() => {
    // SEO safeguard: keep admin out of search indexes
    document.title = "A Flat Records · Admin";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
      document.title = "A Flat Records | Precision in Sound";
    };
  }, []);

  useEffect(() => {
    api.get("/me").then(() => setAuth(true)).catch(() => setAuth(false));
  }, []);

  const Guard = ({ children }) => {
    if (auth === null)
      return (
        <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center text-neutral-500">
          Loading…
        </div>
      );
    if (!auth) return <Navigate to="/admin/login" replace />;
    return <AdminLayout>{children}</AdminLayout>;
  };

  return (
    <AuthCtx.Provider value={{ auth, setAuth }}>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="" element={<Navigate to="/admin/inquiries" replace />} />
        <Route path="inquiries" element={<Guard><Inquiries /></Guard>} />
        <Route path="invoices" element={<Guard><Invoices /></Guard>} />
        <Route path="*" element={<Navigate to="/admin/inquiries" replace />} />
      </Routes>
    </AuthCtx.Provider>
  );
}
